/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-redeclare */
/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-use-before-define */

import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

class Header extends React.Component {

    constructor(props) {
        super();
        this.state = {

        };
    }



    componentDidMount() {

    }

    render() {
        return (
            <div>
                <Container>
                    <Row>
                        <Col style={{ fontSize: '1.2rem' }}>
                            <nlb-header
                                data-applogo="images/logo.png"
                                data-appurl="#">
                                <ui-menu>
                                    <ui-menu-item data-url="./faq" data-text="FAQ" class="mb-2"></ui-menu-item>
                                    <ui-menu-item data-url="https://eresources.nlb.gov.sg/publicationsg/" data-text="PublicationSG" class="mb-2"></ui-menu-item>
                                    {/* <ui-menu-item ><a href="https://eresources.nlb.gov.sg/publicationsg/" target="_self" className="theme-font-bluecolor pe-md-5 pe-sm-3"><img alt="PublicationSG" src="./images/PublicationSG.png" /></a></ui-menu-item> */}
                                </ui-menu>
                                {/* <nlb-suggest data-onesearch="yes"
                                    data-catalogue="yes"
                                    data-withinsiteurl="#withinsite"
                                    data-default="withinsite"
                                    data-advancedurl="#advanced">
                                    <ui-option>
                                        <ui-option-item data-id="custom1" data-name="Custom 1" data-url="#custom1"></ui-option-item>
                                        <ui-option-item data-id="custom2" data-name="Custom 2" data-url="#custom2"></ui-option-item>
                                    </ui-option>
                                </nlb-suggest>
                                <nlb-mylibrary></nlb-mylibrary> */}
                            </nlb-header>
                        </Col>
                    </Row>
                </Container >
                <Container fluid className="p-0" style={{ backgroundColor: '#f8f9fa', fontSize: '1rem' }}>
                    <Container className="p-0">
                        <Row className="m-0">
                            <Col className="p-0">
                                <nlb-notice></nlb-notice>
                            </Col>
                        </Row>
                    </Container>
                </Container >
            </div>

        );
    }
}


export default Header;

